module.exports = __webpack_public_path__ + "img/gb-whatsapp-download-steps.c227d3d8.webp";